// extracted by mini-css-extract-plugin
module.exports = {"logo":"IntegrationDetails-module__logo___9qa5w"};